export const CA_APPLICATION = 'capital.access';
export const CI_APPLICATION = 'capital.insight';
export const CA_ADMIN_ROLE = 'CA_ADMIN_ROLE';
export const CA_CUSTODIAN_MANAGEMENT_ADMIN = 'CA_CUSTODIAN_MANAGEMENT_ADMIN';
export const CA_COMPASS_ROLE = 'CA_COMPASS_ROLE';
export const CA_IMPERSONATION_ADMIN_ROLE = 'CA_IMPERSONATION_ADMIN';
